<div class="toggle-container">
  <div
    *ngFor="let opt of toggleOptions"
    class="toggle-option-container d-flex gap-2 justify-content-center flex-grow-1">
    <input
      type="radio"
      [id]="'toggle-' + opt.label"
      class="visually-hidden toggle-input"
      [checked]="selectedValue === opt.value"
      (change)="onChange(opt.value)" /><label [for]="'toggle-' + opt.label" class="toggle-label">{{ opt.label }}</label>
  </div>
</div>
